import type {ReactElement} from 'react';
import React from 'react';
import type {AiThreeDotsLoaderProps} from './ai-three-dots-loader.types';
import styles from './ai-three-dots-loader.module.scss';

export function AiThreeDotsLoader({size = 16, ...props}: AiThreeDotsLoaderProps): ReactElement {
  return (
    <div className={`${styles.container} ${props.className}`}>
      <div className={styles.loader} style={{width: size}} />
    </div>
  );
}
